import debounce from './debounce';

export default function onResizeDebounced(callback, wait) {
  const function_ = debounce(callback, wait);

  window.addEventListener('resize', function_);
}



// WEBPACK FOOTER //
// ./scripts/util/onResizeDebounced.js